import { render, staticRenderFns } from "./App.vue?vue&type=template&id=233c98ff"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=233c98ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports